export const seoTagValues = {
  common: {
    title: 'Ucare - USEN GROUPが提供する 介護・看護の専門人材向けワークシェアリングアプリ',
    description:
      'UcareはUSEN GROUPが提供する介護・看護の専門人材と人手不足で困っている介護施設・医療機関をつなぐワークシェアリングアプリです。',
    keywords:
      'Ucare,U care,ユーケア,ユウケア,ゆうけあ,ゆーけあ, ワークシェアリング, 介護,医療,介護・医療,スポット,掛け持ち バイト,バイト 即日,単発 バイト,介護 バイト おすすめ',
  },
};
